'use client'
import { FC } from 'react'
import { AppLayout, DefaultPage, NewsPage, TariffsPage } from '@/root/modules/tuuleliinid'
import { useGetPageContent } from '@/root/shared-hooks/sales-static/usePages'
import { News, Page, Slug, Tariff } from '@/root/shared-types'
import { useCustomRouter } from '@/root/shared-hooks'

export const ContentPage: FC = () => {
  const { params } = useCustomRouter()
  const page = params?.page

  const { pageContent } = useGetPageContent(page as Slug, 'tuuleliinid')

  const ContentDefiner = (slug: Slug) => {
    switch (slug) {
      case 'news':
        return <NewsPage news={(pageContent.page || []) as News[]} />
      case 'tariffs':
        return <TariffsPage tariffs={pageContent.page as Tariff[]} />
      default:
        return <DefaultPage {...(pageContent.page as Page)} />
    }
  }

  return <AppLayout>{ContentDefiner(page as Slug)}</AppLayout>
}
